import { OSS_API } from '@/constants/API';
import { PlusOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import { message, Modal, Upload } from 'antd';
import { useEffect, useState } from 'react';
import imgResize from './imgResize';

const getBase64 = (file): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const ImgUpload = ({
  defaultUrl,
  callback,
  custIcon,
  width = 2000,
  height = 2000,
  mode = 'fit',
  disabled = false,
}) => {
  const [fileUrl, setFileUrl] = useState('');
  const props: UploadProps = {
    name: 'file',
    action: OSS_API + 'upload',
    headers: {
      authorization: 'Bearer ' + localStorage.getItem('user_token'),
    },
    accept: '.jpg,.jpeg,.png',
    maxCount: 1,
    async beforeUpload(file) {
      const isJpgOrPng =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg';
      if (!isJpgOrPng) {
        message.error('你只能上传JPG/PNG/WEBP格式的图片!');
        setTimeout(() => {
          setFileList([]);
        });
        return Promise.reject(false);
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error('图片必须小于2MB!');
        setTimeout(() => {
          setFileList([]);
        });
        return Promise.reject(false);
      }
      return await imgResize(file, {
        width,
        height,
        mode,
        type: file.type,
        onFail: () => {
          message.error('上传失败!');
          setTimeout(() => {
            setFileList([]);
          });
        },
        onSuccess: (resizeFile?: UploadFile) => {
          if (!resizeFile) {
            resizeFile = file;
          }
          resizeFile.uid = file.uid;

          setTimeout(() => {
            setFileList([resizeFile || file]);
          });
        },
      });
    },

    onChange(info) {
      try {
        if (info.file.status !== 'uploading') {
        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} 文件上传成功！`);
          callback && callback(info.file.response.data.url);
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} 文件上传失败`);
        }
      } catch (error) {
        message.error(`${error}`);
      }
    },
    // onRemove() {
    //     setFileUrl("")
    // }
  };
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const [fileList, setFileList] = useState<UploadFile[]>(
    defaultUrl
      ? [
          {
            uid: '1',
            name: '预览',
            status: 'done',
            url: defaultUrl,
          },
        ]
      : [],
  );

  useEffect(() => {
    setFileList(
      defaultUrl
        ? [
            {
              uid: '1',
              name: '预览',
              status: 'done',
              url: defaultUrl,
            },
          ]
        : [],
    );
  }, [defaultUrl]);

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1),
    );
  };

  const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length && newFileList[0].status == 'done') {
      callback && callback(newFileList[0].response.data.url);
    } else {
      callback && callback('');
    }
    // try {
    //     if (info.file.status !== 'uploading') {
    //     }
    //     if (info.file.status === 'done') {
    //         message.success(`${info.file.name} ${t("Upload Success")}`);
    //         setFileList(  [{
    //             uid: info.file.response.data.url,
    //             name: info.file.name,
    //             status: 'done',
    //             url: info.file.response.data.url,
    //         }]);
    //         callback && callback(info.file.response.data.url)
    //     } else if (info.file.status === 'error') {
    //         message.error(`${info.file.name} ${t("Upload failed")}`);
    //     }
    // } catch (error) {
    //     message.error(`${error}`);
    // }
  };
  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      {custIcon ? (
        custIcon
      ) : (
        <>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </>
      )}
    </button>
  );

  return (
    <>
      <Upload
        {...props}
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        disabled={disabled}
      >
        {fileList.length >= 1 ? null : uploadButton}
      </Upload>
      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>
    </>
  );
};
